import { render } from "./CarousselPartenaire.vue?vue&type=template&id=90ff2d0e"
import script from "./CarousselPartenaire.vue?vue&type=script&lang=js"
export * from "./CarousselPartenaire.vue?vue&type=script&lang=js"

import "./CarousselPartenaire.vue?vue&type=style&index=0&id=90ff2d0e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__